export const shoulderIsoAbdPowText = {
  values: [
    { value: 'ShoulderIsoAbdPow', text: 'Ja', score: 1 },
    { value: 'ShoulderIsoAbdPow', text: 'Nei', score: 0 },
    { value: 'ShoulderIsoAbdPow', text: 'Ikke aktuelt', score: -1 },
  ],
};
